module.exports = __webpack_public_path__ + "img/tipo_cespiti_emt.217284fd.png";